import { useParams } from "react-router-dom";
import EditClientAccount from "./EditClientAccount";
import { useGetClientAccountByIdQuery } from "../../../../../reactQueries/AppApi/rqHooksForClientAccount";
import { Fragment } from "react";
import MpgErrorDialog from "../../../../../common/dialog/MpgErrorDialog";
import { useGetAccountAdminListQuery, useGetLanguageListQuery, useGetCurrencyListQuery, useGetClientTypeClassificationQuery } from "../../../../../reactQueries/commonRQHooks";

const EditClientAccountHome = () => {

    let { id } = useParams()

    const { isSuccess, isFetching, data: clientAccountById, isError } = useGetClientAccountByIdQuery({ clientAccountId: id })

    const { data: LangList } = useGetLanguageListQuery();

    const { data: CurrencyList } = useGetCurrencyListQuery();

    const { data: ClientTypeList } = useGetClientTypeClassificationQuery();
    
    const { data: accountAdminListFromAPI } = useGetAccountAdminListQuery();



    // console.log("gl-data", clientAccountById)

    return (
        <Fragment>
            {
                (!!isFetching) && "Wait Loading...."
            }
            {
                (!!isSuccess) && (<EditClientAccount
                    clientAccountDataById={clientAccountById}
                    LangList={LangList || []}
                    CurrencyList={CurrencyList || []}
                    ClientTypeList={ClientTypeList || []}
                    accountAdminListFromAPI={accountAdminListFromAPI || []}
                />)
            }
            <MpgErrorDialog
                open={!!isError}
            />
        </Fragment>
    )


}
export default EditClientAccountHome